import ApiService from './ApiService';

class DwvService {
  static async fetchDevelopmentPrivateInfo(developmentId) {
    return ApiService.get(
      `/api3/dwv/development/${developmentId}/private-info/`,
      undefined,
      true
    );
  }

  static async fetchPropertyPrivateInfo(propertyId) {
    return ApiService.get(
      `/api3/dwv/property/${propertyId}/private-info/`,
      undefined,
      true
    );
  }

  static async fetchPrivateInfo({ propertyId, developmentId }) {
    if (propertyId) {
      return DwvService.fetchPropertyPrivateInfo(propertyId);
    }
    if (developmentId) {
      return DwvService.fetchDevelopmentPrivateInfo(developmentId);
    }
    return null;
  }
}

export default DwvService;
